module.exports = __webpack_public_path__ + "img/gallery3.577266e6.webp";